import Report from "components/app/report/Report";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { rootRoutes } from "routes";
import ScreenReportCategories from "./categories";
import ScreenIndividualReportType from "./waste/individualReportType";
import ScreenBilgeReport from "./waste/bilgeWater";
import ScreenORSReport from "./waste/ors";
import ScreenCargoSlop from "./waste/cargoSlop";
import ScreenOilSpillsInWater from "./other/oilspillsInWater";
import ScreenBiofouling1 from "./other/biofouling1";
import ScreenBiofouling2 from "./other/biofouling2";
import ScreenComprehensiveNoonReport from "./comprehensive-noon-report/comprehensive-noon-report";
import ScreenCNRRanges from "./comprehensive-noon-report/cnr-ranges";
import ScreenNavNucReport from "./nav-nuc/nav-nuc";
// Environment Screens
import ScreenEmissions from "./environment/emissions";
import ScreenCleaningChemicals from "./environment/cleaningChemicals";
import ScreenPackaging from "./environment/packaging";
import ScreenRefrigerants from "./environment/refrigerant";
import ScreenEmfUsage from "./environment/emfUsage";
import ScreenLngReport from "./lng/index";
import ScreenSpeedLossReport from "./speedloss/index";

const reportsRoutes = rootRoutes.children.app.children.reports.children;
type ScreenUserProps = React.PropsWithChildren<{}>;
function ScreenReport(props: ScreenUserProps) {
	return (
		<Report>
			<Switch>
				<Route
					exact
					path={reportsRoutes.categories.path}
					component={ScreenReportCategories}
				/>
				{/* Waste */}
				<Route
					exact
					path={
						reportsRoutes.categories.children.waste.reportForWasteBilgeWater
							.path
					}
					component={ScreenBilgeReport}
				/>
				<Route
					exact
					path={
						reportsRoutes.categories.children.waste.reportForWasteGarbage.path
					}
					component={ScreenIndividualReportType}
				/>
				<Route
					exact
					path={reportsRoutes.categories.children.waste.reportForWasteORS.path}
					component={ScreenORSReport}
				/>
				<Route
					exact
					path={
						reportsRoutes.categories.children.waste.reportForWasteCargoSlop.path
					}
					component={ScreenCargoSlop}
				/>
				<Route
					exact
					path={
						reportsRoutes.categories.children.other.reportForOilSpillsInWater
							.path
					}
					component={ScreenOilSpillsInWater}
				/>
				<Route
					exact
					path={
						reportsRoutes.categories.children.other.reportForBiofouling1.path
					}
					component={ScreenBiofouling1}
				/>
				<Route
					exact
					path={
						reportsRoutes.categories.children.other.reportForBiofouling2.path
					}
					component={ScreenBiofouling2}
				/>
				{/* Environment Routes */}
				<Route
					exact
					path={
						reportsRoutes.categories.children.environment.reportForEmissions
							.path
					}
					component={ScreenEmissions}
				/>
				<Route
					exact
					path={
						reportsRoutes.categories.children.environment
							.reportForCleaningChemicals.path
					}
					component={ScreenCleaningChemicals}
				/>
				<Route
					exact
					path={
						reportsRoutes.categories.children.environment.reportForPackaging
							.path
					}
					component={ScreenPackaging}
				/>
				<Route
					exact
					path={
						reportsRoutes.categories.children.environment.reportForRefrigerants
							.path
					}
					component={ScreenRefrigerants}
				/>
				<Route
					exact
					path={
						reportsRoutes.categories.children.environment.reportForEmfUsage.path
					}
					component={ScreenEmfUsage}
				/>
				{/* CNR */}
				<Route
					exact
					path={
						reportsRoutes.categories.children.comprehensiveNoonReport
							.comprehensiveNoonReport.path
					}
					component={ScreenComprehensiveNoonReport}
				/>
				<Route
					exact
					path={
						reportsRoutes.categories.children.comprehensiveNoonReport.cnrRanges
							.path
					}
					component={ScreenCNRRanges}
				/>
				<Route
					exact
					path={reportsRoutes.categories.children.navnuc.navnuc.path}
					component={ScreenNavNucReport}
				/>
				<Route
					exact
					path={reportsRoutes.categories.children.lng.lngReport.path}
					component={ScreenLngReport}
				/>
				<Route
					exact
					path={reportsRoutes.categories.children.speedloss.speedlossReport.path}
					component={ScreenSpeedLossReport}
				/>

				<Route render={RedirectComponent} />
			</Switch>
		</Report>
	);
}

function RedirectComponent() {
	return <Redirect to={reportsRoutes.categories.url()} />;
}
export default ScreenReport;
